import React from "react";
import classes from "./GqlWithLoader.scss";
import Loading from "UIComponents/Loading";
import classNames from "classnames";
import { connect } from "react-redux";
import LoadingBar, { showLoading, hideLoading } from "react-redux-loading-bar";
import { getHOCDisplayName } from "Utils";
import { colors } from "@toddle-edu/ds-theme";
import ACLStore from "lib/aclStore";

const loadingBarStyle = {
  backgroundColor: colors.red66,
  height: "2px",
  position: "fixed",
  top: "0",
  left: "0",
};

function withLoader(WrappedComponent) {
  class WithLoader extends React.PureComponent {
    constructor(props) {
      super(props);
      this.wrappedComponentRef = null;
    }

    UNSAFE_componentWillReceiveProps = nextProps => {
      if (nextProps.isLoading != this.props.isLoading) {
        if (nextProps.isData && this.props.showLoaderBar) {
          if (nextProps.isLoading) {
            nextProps.showLoading();
            //console.log("Show Loading")
          } else {
            nextProps.hideLoading();
            //console.log("Hide loading");
          }
        }
      }
    };

    componentDidMount = () => {
      // console.log('nav', navigator.onLine);

      if (this.props.isData && this.props.showLoaderBar) {
        if (this.props.isLoading) {
          this.props.showLoading();
        } else {
          this.props.hideLoading();
        }
      }
    };

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.isData != this.props.isData) {
        if (this.props.customRef) {
          //this.props.customRef(this.wrappedComponentRef);
        }
      }
    }

    render() {
      const {
        isData,
        isLoading,
        loadingStyle,
        forwardedRef,
        containerStyle,
        showLoadingIcon,
        loadingContainerStyle,
        showLoaderBar,
        isMiniLoader,
        showConsole,
        customLoadingComponent,
      } = this.props;

      const container = classNames(
        { [classes.container]: true },
        {
          [classes.noScrollContainer]: isLoading && !isData,
        }
      );

      return (
        <div
          className={container}
          style={containerStyle}
          data-component={getHOCDisplayName(WrappedComponent)}
        >
          {isData ? (
            <WrappedComponent {...this.props} ref={forwardedRef} />
          ) : null}
          {isLoading && !isData && customLoadingComponent && !showLoadingIcon
            ? customLoadingComponent
            : null}
          {isLoading && !isData && !!showLoadingIcon ? (
            <Loading
              loadingStyle={loadingStyle}
              containerStyle={loadingContainerStyle}
              isMiniLoader={isMiniLoader}
            />
          ) : null}
          {!!showLoaderBar && <LoadingBar style={loadingBarStyle} />}
        </div>
      );
    }
  }

  WithLoader.displayName = `WithLoader(${getHOCDisplayName(WrappedComponent)})`;
  WithLoader.defaultProps = {
    showLoaderBar: true,
    showLoadingIcon: true,
    loadingStyle: {},
    containerStyle: {},
    loadingContainerStyle: {},
    isMiniLoader: false,
  };
  const mapActionCreators = {
    showLoading,
    hideLoading,
  };

  const mapStateToProps = (state, ownProps) => {
    const { showLoaderBar = true } = ownProps;

    const _showLoaderBar =
      showLoaderBar && ACLStore.can("FeatureFlag:ShowTopLoadingBar");
    return { showLoaderBar: _showLoaderBar };
  };

  return connect(
    mapStateToProps,
    mapActionCreators
  )(
    React.forwardRef(function withLoader(props, ref) {
      return <WithLoader {...props} forwardedRef={props.customRef} />;
    })
  );
}

export default withLoader;
